"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderedOperationRecipe = void 0;
const prepare_1 = require("../types-internal/prepare");
function orderedOperationRecipe(map, resolver, partition) {
    return function (baseMapper) {
        const mapper = (0, prepare_1.prepare)(baseMapper);
        const mapped = map.call(this, ((value) => resolver(mapper(value), (key) => [key, value])));
        return partition.call(mapped, ([a], [b]) => a === b);
    };
}
exports.orderedOperationRecipe = orderedOperationRecipe;
